import { useRef } from 'react'
import Slider from 'react-slick'
import styled from 'styled-components'

export interface BannerImage<Data> {
  type?: 'video' | 'image'
  src?: string
  previewImageSrc?: string
  alt: string
  data?: Data
}

export interface Props<Data> {
  images: BannerImage<Data>[]
  width?: string | number
  height?: string | number
  radius?: number
  onClick?: (image: BannerImage<Data>) => void
}
const ImageBanner = <Data,>({
  images,
  width = '100%',
  height = 'auto',
  radius = 8,
  onClick,
}: Props<Data>): JSX.Element => {
  const sliderRef = useRef<Slider>(null)

  const handleClickBanner = (image: BannerImage<Data>) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isSlideAnimating = (sliderRef.current as any).innerSlider.state.animating
    if (!isSlideAnimating && onClick) {
      onClick(image)
    }
  }

  return (
    <StyledContainer $radius={radius} aria-label="image-banner">
      <Slider
        ref={sliderRef}
        dots={false}
        speed={500}
        autoplay={true}
        autoplaySpeed={4000}
        arrows={false}
        slidesToShow={1}
        slidesToScroll={1}
        infinite={images.length > 1}
      >
        {images.map((image, index) => (
          <StyledSliderItem key={index} onClick={() => handleClickBanner(image)}>
            {image.type === 'video' ? (
              <video src={image.src} width={width} height={height} poster={image.previewImageSrc} autoPlay muted loop />
            ) : (
              <img src={image.src} width={width} height={height} alt={image.alt} />
            )}
          </StyledSliderItem>
        ))}
      </Slider>
    </StyledContainer>
  )
}

const StyledContainer = styled.div<{ $radius: number }>`
  overflow: hidden;
  line-height: 0;
  width: 100%;
  user-select: none;
  .slick-list {
    border-radius: ${({ $radius }) => $radius}px;
  }
`
const StyledSliderItem = styled.div`
  user-select: none;
  cursor: pointer;
  outline: 0;
`

export default ImageBanner
